

const NoInfoScreen = () => {
    return (
        <div style={{
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh'
        }}>
            <p style={{ color: "#E7E7E7", fontFamily: "vwRegular" }}>No hay datos que mostrar.</p>
        </div>
    )
}

export default NoInfoScreen